import { Component } from '@angular/core';
import { Http } from '@angular/http';
import {LoadingController, ModalController, AlertController, ViewController} from "ionic-angular";
import {Params} from "../../params";
import * as firebase from "firebase/app";
import * as moment from 'moment';

@Component({
  selector: 'page-orders',
  templateUrl: 'orders.html',
})
export class OrdersPage {
  orders = [];
  items = [];
  money = Params.money;
  step = 1;
  todate = Params.toDate;
  activeOrder = {};
  month;
  year;
  years = [];
  constructor(
    private loadingCtrl: LoadingController,
    public http: Http,
    public viewCtrl: ViewController,
    public alertCtrl: AlertController
  ) {
    let actual_year = Number(moment().format("YYYY"));
    let first_year = 2017;
    let end = (actual_year-first_year)+2;
    for(let y=0;y<end;y++){
      this.years.push(first_year+y);
    }

    this.month = moment().format("MM");
    this.year = actual_year;

    this.load();
  }

  findParam(param, order){
    let ret = 'n/a';
    if(order.meta_data){
      const f = order.meta_data.filter((x) => x.key == param);
      if(f.length) ret = f[0].value;
    }
    return ret;
  }

  addpayment(c){
    const payment = {
      customer:{
        address: c.shipping.address_1,
        email: c.billing.email,
        id: null,
        metadata: null,
        name: c.billing.first_name + ' '+ c.billing.last_name
      },
      amount : Number(c.total),
      application_fee: null,
      created_at: firebase.firestore.FieldValue.serverTimestamp(),
      currency: "CLP",
      description: "Pago Manual",
      gateway: "Transferencia",
      refund: null,
      status: "successful",
      payment:{
        amount: Number(c.total),
        application_fee: 0,
        extra_fee: 0,
        fee: 0,
        gateway: 'transfer',
        installments: 1,
        payment_type: 'transfer'
      }
    }
    const prompt = this.alertCtrl.create({
      title: 'Crear pago a '+c.billing.first_name,
      subTitle: 'Con esta acción va a declarar como pagada la transferencia por '+this.money(c.total)+'. ¿Está seguro?',
      buttons: [
        {
          text: 'Cancelar',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Crear Pago',
          handler: data => {
            firebase.firestore().collection('payments')
              .doc(moment().format('YYYYMM'))
              .collection('transactions')
              .add(payment)
              .then((docRef)=>{
                firebase.firestore().collection('preorders')
                  .doc(c.xid)
                  .set({
                    payment_created: docRef.id
                  },{
                    merge: true
                  })
                  .then(()=>this.load())
              })
          }
        }
      ]
    });
    prompt.present();
  }

  route(c){
    const prompt = this.alertCtrl.create({
      title: 'Asignar ruta a '+c.billing.first_name,
      inputs: [
        {
          name: 'route',
          placeholder: 'Ruta',
          type: "text",
          value: c.route
        },
      ],
      buttons: [
        {
          text: 'Cancelar',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Asignar Ruta',
          handler: data => {
            firebase.firestore().collection('preorders')
              .doc(c.xid)
              .set({
                route: data.route
              },{
                merge: true
              })
              .then(()=>this.load())
          }
        }
      ]
    });
    prompt.present();
  }

  payment_name(name){
    let ret = name;
    if(name == 'qvo_webpay_plus') ret = 'Webpay';
    if(name == 'bacs' || name == 'Bank Deposit') ret = 'Transferencia';
    return ret;
  }


  load(){
    let loading = this.loadingCtrl.create({
      content : "Espere porfavor"
    })
    loading.present();
    const greaterThan = moment(`${this.year}-${this.month}-01`).startOf('month').toDate();
    const lessThan = moment(`${this.year}-${this.month}-01`).endOf('month').toDate();
    firebase.firestore().collection('preorders')
      .where('createdAt', '>=', greaterThan).where('createdAt', '<=', lessThan)
      .orderBy('createdAt', 'desc')
      .get()
      .then(async(resp) => {
        if(!resp.empty){
          const temp = [];
          resp.forEach((o) => {
            const obj = { xid: o.id, ... o.data()};
            if(obj['billing'] == 'undefined') obj['shipping'] = {};
            temp.push(obj)
          });
          console.log(temp);
          this.orders = temp;
          this.initializeItems();
        }

        loading.dismiss();

      })
  }

  initializeItems(){
    this.items = this.orders
  }

  getItems(ev: any) {
    this.initializeItems();
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        try {
          return (
            (item.billing.first_name.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (item.billing.last_name.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            // (item.rut.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (item.billing.email.toLowerCase().indexOf(val.toLowerCase()) > -1)
          );
        }catch(err) {
          console.log('item error', item);
          console.log('error', err.message);
          return true;
        }
      })
    }
    // if(this.items.length>100){this.items = this.items.splice(0,100);}
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TransfersPage');
  }

  open(order){
    this.step = 2;
    this.activeOrder = order;
    // this.viewCtrl.dismiss(order);
  }

}



// WEBPACK FOOTER //
// ./src/pages/pay/orders/orders.ts